module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/symbol-observable/index.js
// module id = 836
// module chunks = 168707334958949